import React from 'react'
import LogoAppWhoop from "@/assets/appwhoop_ticket_logo.webp"

export default function RespaldoAppWhoop() {
  return (
    <div className="flex flex-col bg-aw-blueblack px-2 py-4 rounded-xl">
        <img src={LogoAppWhoop} alt="AppWhoop" className="h-8 object-contain" />
        <p className="text-center text-white text-[0.65rem]">
            El contenido de cada Ticket es responsabilidad exclusiva de la Empresa afiliada. AppWhoop Ticket no se responsabiliza ni interviene en valores, horarios, ubicación, descuentos, beneficios o información. La Empresa es el único y exclusivo responsable de la producción y organización, en forma oportuna y en conformidad a la ley.
        </p>
    </div>
  )
}
